module.exports = __webpack_public_path__ + "img/thumb-te-hair-je-ne-peux.b7238b88.jpg";